import { Fragment } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { MetaField, SectionLabel, StatusPill } from './components';
import { COLORS } from './tokens';

export type MetaItem = { label: string; value: string; pill?: boolean };

export const SIS_MISSING_LINE = 'Home language, years in EL, EL status, program model, IEP and 504 come from your SIS file.';

function Field({ item }: { item: MetaItem }) {
  if (item.pill) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, minWidth: 0 }}>
        <SectionLabel>{item.label}</SectionLabel>
        <Box>
          <StatusPill label={item.value} />
        </Box>
      </Box>
    );
  }
  return <MetaField label={item.label} value={item.value} />;
}

export function MetaStrip({
  items,
  sisMissing = false,
  onUploadSis,
}: {
  items: MetaItem[];
  sisMissing?: boolean;
  onUploadSis?: () => void;
}) {
  const visible = items.filter((item) => item.value.trim() !== '');
  if (sisMissing) {
    const teacher = visible.find((item) => item.label === 'EL Teacher');
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, py: 2.5, flexWrap: 'wrap' }}>
        {teacher && <Field item={teacher} />}
        {teacher && <Box data-testid="meta-divider" sx={{ width: '1px', alignSelf: 'stretch', bgcolor: COLORS.hairline }} />}
        <Typography sx={{ flex: 1, minWidth: 240, fontSize: 16, fontWeight: 500, lineHeight: '24px', color: COLORS.muted }}>
          {SIS_MISSING_LINE}
        </Typography>
        {onUploadSis && (
          <Button onClick={onUploadSis} sx={{ textTransform: 'none', fontWeight: 600, fontSize: 16, color: COLORS.navy }}>
            Upload SIS file
          </Button>
        )}
      </Box>
    );
  }
  if (visible.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 3, py: 2.5, flexWrap: 'wrap' }}>
      {visible.map((item, i) => (
        <Fragment key={item.label}>
          {i > 0 && (
            <Box
              data-testid="meta-divider"
              sx={{ width: '1px', alignSelf: 'stretch', bgcolor: COLORS.hairline }}
            />
          )}
          <Field item={item} />
        </Fragment>
      ))}
    </Box>
  );
}
